import React from 'react';
import Input from '../../../../../../../components/Input/Input';
import { useLocation } from 'react-router-dom';
import './ServiceOfferedDetail.css';
//utils
import { formatDate, formatTime } from '../../../../../../../utils/utils';

const ServiceOfferedDetail = () => {
  const location = useLocation();
  const { serviceData } = location.state || {};

  return (
    <div className="service-detail-container">
      <h2 className="service-detail-title">
        <span className="title-highlight">Consult</span> History of Services Received
      </h2>

      <div className="service-detail-form">
        {/* First row */}
        <div className="form-row">
          <div className="form-field">
            <h3>Request Folio</h3>
            <Input
              type="text"
              value={serviceData.service_id}
              disabled
            />
          </div>
          
          <div className="form-field">
            <h3>Category</h3>
            <Input
              type="text"
              value={serviceData.category}
              disabled
            />
          </div>
          
          <div className="form-field">
            <h3>Subcategory</h3>
            <Input
              type="text"
              value={serviceData.subcategory}
              disabled
            />
          </div>
        </div>

        {/* Second row */}
        <div className="form-row">
          <div className="form-field">
            <h3>Supplier</h3>
            <Input
              type="text"
              value={serviceData.provider}
              disabled
            />
          </div>
          
          <div className="form-field">
            <h3>Type of service</h3>
            <Input
              type="text"
              value={serviceData.service_type}
              disabled
            />
          </div>
          
          <div className="form-field">
            <h3>Date</h3>
            <Input
              type="text"
              value={formatDate(serviceData.created_at)}
              disabled
            />
          </div>
        </div>

        {/* Third row */}
        <div className="form-row">
          <div className="form-field">
            <h3>Time</h3>
            <Input
              type="text"
              value={formatTime(serviceData.created_at)}
              disabled
            />
          </div>
          
          <div className="form-field">
            <h3>Number of barter bucks used</h3>
            <Input
              type="text"
              value={serviceData.service_cost}
              disabled
            />
          </div>
          
          <div className="form-field">
            <h3>Status</h3>
            <Input
              type="text"
              value={serviceData.status}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceOfferedDetail;
